import React from 'react';
import { Input, Form } from '@b-design/fusion';
import $i18n from '@/i18n';
import Requests from '@/services/request';
import Button, { FormSubmit } from '@/components/Button';
interface VersionDetail {
  // 发布描述
  changelog: string;
  // 应用所在渠道名称
  channelName: string;
  // 应用版本
  version: string;
  // 应用id
  appId: string;
  // 应用渠道id
  channelCode: string;
}
interface Props {
  // 空间id
  spaceId: string | (string | null)[] | null;
  // 抽屉表单显隐回调
  setVisible: (v: boolean) => void;
  // 版本信息详情
  versionDetail: VersionDetail;
  // 初始化数据函数
  initDataSource: () => void;
}

const Submit: React.FC<Props> = ({ setVisible, versionDetail, initDataSource, spaceId }) => {
  const { channelName, version, appId, channelCode, changelog } = versionDetail;

  // todo: 提交表单
  const submitForm = async (value) => {
    const res = await Requests.post('/rest/intercnn/app/publish/version/startApprove', {
      appId,
      sourceSpaceId: spaceId,
      channelCode,
      version,
      changelog: value?.releaseNote,
    })
    if (res) {
        setVisible(false);
        initDataSource();
      }
  };

  return (
    <div className="submit-container">
      <Form
        className="submit-form"
        value={
          versionDetail && {
            channel: channelName,
            version,
          }
        }
      >
        <Form.Item
          name="channel"
          label={$i18n.get({
            id: 'aopf.pages.miniapp.version.info.confirm.Target.Channel',
            dm: '目标渠道',
          })}
          disabled
          minLength={2}
          maxLength={36}
        >
          <Input
            placeholder={$i18n.get({
              id: 'aopf.pages.miniapp.drawer.form.Miniapp.Name.placeholder',
              dm: '请输入唯一的名称，长度为2~36个字符',
            })}
            style={{ width: '470px' }}
          />
        </Form.Item>
        <Form.Item
          name="version"
          label={$i18n.get({
            id: 'aopf.pages.miniapp.version.info.Version',
            dm: '版本',
          })}
          disabled
          minLength={2}
          maxLength={36}
        >
          <Input
            placeholder={$i18n.get({
              id: 'aopf.pages.miniapp.drawer.form.Miniapp.Name.placeholder',
              dm: '请输入唯一的名称，长度为2~36个字符',
            })}
            style={{ width: '470px' }}
          />
        </Form.Item>
        <Form.Item
          name="releaseNote"
          label={$i18n.get({
            id: 'aopf.pages.miniapp.version.info.Release.Note',
            dm: '发布说明',
          })}
          minLength={2}
          maxLength={36}
          minmaxLengthMessage={$i18n.get({
            id: 'aopf.component.submit.PleaseEnterAReleaseDescription',
            dm: '请输入2-36个字符的发布说明',
          })}
        >
          <Input.TextArea style={{ width: '470px' }} />
        </Form.Item>
        <Form.Item name="agree" className="nextBtn">
          <FormSubmit
            type="primary"
            onClick={submitForm}
            validate
            style={{
              height: 40,
              borderRadius: 4,
              fontWeight: 500,
              fontSize: 16,
              color: '#fff',
              letterSpacing: '0.15px',
            }}
          >
          {$i18n.get({ id: 'aopf.pages.miniapp.version.info.confirm.Ok', dm: '确定' })}
          </FormSubmit>
          <Button className="nextBtn-cancel" onClick={() => setVisible(false)}>
            {$i18n.get({ id: 'aopf.pages.miniapp.version.info.confirm.Cancel', dm: '取消' })}
          </Button>
        </Form.Item>
      </Form>
    </div>
  );
};
export default Submit;
